/**
 * Encompass milestone-template configuration — pcb-loans-api v3/loans/admin/encompass/* (loans_070, Bill 2026-11-03).
 * Which milestone files the Encompass post-closing task is set PER TEMPLATE here, never in code. Writes need a reason and are
 * audited in loans.AdminAudit with before/after.
 */

import { loansApi } from '../loansApi';

export interface EncompassTemplate {
  templateId: number;
  name: string;
  generation: 'new' | 'legacy' | string;
  active: boolean;
  /** Null = loans on this template never file a post-closing task. */
  postClosingMilestone: string | null;
  notes: string | null;
  updatedBy: string;
  updatedUtc: string;
}

export interface EncompassTrackedMilestone {
  name: string;
  tracked: boolean;
  notes: string | null;
  updatedBy: string;
  updatedUtc: string;
}

export interface EncompassConfig {
  templates: EncompassTemplate[];
  milestones: EncompassTrackedMilestone[];
  /** The milestones the watcher queries (active templates' tracked post-closing milestones). */
  triggerMilestones: string[];
}

export interface TemplateSave {
  active: boolean;
  postClosingMilestone: string | null;
  notes: string | null;
}

export interface TemplateAdd extends TemplateSave {
  templateId: number;
  name: string;
  generation: 'new' | 'legacy';
}

export const encompassConfigApi = {
  get: () => loansApi.get<EncompassConfig>('v3/loans/admin/encompass/config'),
  saveTemplate: (templateId: number, body: TemplateSave, reason: string) =>
    loansApi.send<{ template: EncompassTemplate }>('PUT', `v3/loans/admin/encompass/templates/${templateId}`, body, reason),
  addTemplate: (body: TemplateAdd, reason: string) =>
    loansApi.send<{ template: EncompassTemplate }>('POST', 'v3/loans/admin/encompass/templates', body, reason),
  /** The name travels in the body: "Waiting on Services/Processing" cannot ride safely in a path segment. */
  saveMilestone: (name: string, tracked: boolean, notes: string | null, reason: string) =>
    loansApi.send<{ milestone: EncompassTrackedMilestone }>('PUT', 'v3/loans/admin/encompass/milestones', { name, tracked, notes }, reason),
};
